import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Category, Lookup, LookupCategory } from '../models/lookup-category';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class LookupCategoryService implements OnDestroy{

  onChanged: BehaviorSubject<any> = new BehaviorSubject([]);
  private _lookups: Lookup[];
  private _categories: Category[];

  constructor() {}

  ngOnDestroy(): void {
    
  }

  // MRD - stash values, refresh lookupCategories and notify listeners of change
  set lookups(val: Lookup[]){
    this._lookups = val;
    const lookupCategories: LookupCategory[] = [];
    val.forEach((i) => lookupCategories.push(...i.lookupCategories));
    this.onChanged.next(lookupCategories);
  }

  set categories(val: Category[]){
    this._categories = val;
    const lookupCategories: LookupCategory[] = [];
    val.forEach((i) => lookupCategories.push(...i.lookupCategories));
    this.onChanged.next(lookupCategories);
  }

  // MRD - use the stashed values to help hydrate calling services
  getLookupById(id: number): Observable<Lookup>{
    const val = this._lookups.find((i) => i.id === id);
    return of(val);
  }

  getCategoryById(id: number): Observable<Category>{
    const val = this._categories.find((i) => i.id === id);
    return of(val);
  }
}
